import * as React from "react";
import { X } from "lucide-react";

import { cn } from "~/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  onClear?: () => void;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, onClear, ...props }, ref) => {
    return (
      <div
        className={cn(
          "flex items-center h-10 w-full rounded-md border bg-input text-foreground px-3 py-2 text-sm placeholder:text-muted-foreground focus-within:ring-2 focus-within:ring-ring focus-within:border-ring",
          className,
        )}
      >
        {icon && <span className="mr-2 text-muted-foreground">{icon}</span>}
        <input
          type={type}
          className={cn(
            "flex-1 bg-transparent w-full focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-red-500",
            className,
          )}
          ref={ref}
          {...props}
        />
        {onClear && props.value && (
          <button type="button" onClick={onClear}>
            <X />
          </button>
        )}
      </div>
    );
  },
);

Input.displayName = "Input";

export { Input };
